// src/store/index.js
import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import journey from './modules/journey';
import pokemon from './modules/pokemon';
import trainer from './modules/trainer';
import dashboard from './modules/dashboard';
import city from './modules/city';
import changelog from './modules/changelog';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        user,
        journey,
        pokemon,
        trainer,
        dashboard,
        city,
        changelog,
    }
});